<template>
  <ais-hits>
    <template #default="{ items }">
      <dashboard-section :title="getTitle(items)" dataTestId="current-attribute-display" class="h-[420px]">
        <div class="flex-1 overflow-x-auto" data-testid="current-stage-cards-container">
          <data-table
            :value="getFilteredResults(items)"
            :rows="25"
            tableStyle="w-full; border-spacing: 0 !important"
            :pt="myStudentsDataTableTheme"
          >
            <column :header="fieldLabel">
              <template #body="{ data }">{{ getDisplayName(data) }}</template>
            </column>
            <column :header="valueLabel" :pt="ptColumn">
              <template #body="{ data }"
                ><custom-button label="Action" dataTestId="accept-button" @click="acceptClick"
              /></template>
            </column>
          </data-table>
        </div>
      </dashboard-section>
    </template>
  </ais-hits>
</template>
<script setup>
import { computed, inject, ref } from "vue";

import { AisHits } from "vue-instantsearch/vue3/es";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

import { useSearchClient } from "@/composables/useSearchClient";

import { myStudentsDataTableTheme } from "../primeVueTheme";
import DashboardSection from "./DashboardSection.vue";
import CustomButton from "../Navigation/CustomButton.vue";

const props = defineProps({
  filterValues: {
    type: Array,
    default: [],
  },
  filterField: {
    type: String,
  },
  title: {
    type: String,
    default: "",
  },
  fieldLabel: {
    type: String,
    default: "Name",
  },
  valueLabel: {
    type: String,
    default: "Value",
  },
  includeCount: {
    type: Boolean,
    default: false,
  },
  limit: {
    type: Number,
    default: 10,
  },
});

const { getHitsPerPage } = useSearchClient();

const ptColumn = ref({
  headerContent: { style: { "justify-content": "center" } },
  bodyCell: { style: { "text-align": "center" } },
});

const acceptClick = () => {
  console.log("Button Clicked");
};

const getDisplayName = (dataItem) => {
  return `${dataItem.student.first_name_legal} ${dataItem.student.last_name}`;
};

const getTitle = computed(() => (items) => {
  if (props.includeCount) {
    const filteredItems = getFilteredResults.value(items);
    const qualifier = getHitsPerPage() === filteredItems.length ? ">= " : "";
    return `${props.title} (${qualifier}${filteredItems.length})`;
  }
  return props.title;
});

const getDataItem = (item, field) => {
  const path = field.split(".");
  let result = item;
  path.forEach((pathElement) => {
    result = result[pathElement];
    if (!result) {
      return "";
    }
  });
  return result ?? "";
};

const getFilteredResults = computed(() => (data) => {
  if (!props.filterField || props.filterValues.length === 0) {
    return data;
  }
  return data.filter((dataItem) => {
    const item = getDataItem(dataItem, props.filterField);
    const exists = props.filterValues.some((filter) => {
      return item === filter;
    });
    return exists;
  });
});
</script>
